// Pure helper for Tailwind ModalComponents layered with legacy dialogs (see modal_component_controller.js).
// Unit-tested without a DOM. Goes away with the Bootstrap modal runtime (ENG-35508).

// Tailwind ModalComponents sit at z-99999. A Bootstrap `.modal` opened while one is visible gets
// bumped above that (modal.js `show.bs.modal`), and TinyMCE 4 floatpanels (its dialogs and menus)
// start at z-100000 (tinymce_config). Neither is on the esc_stack, so a Tailwind modal underneath
// must leave Escape to them rather than close itself.
const LAYERED_ABOVE_Z_INDEX = 99999

/**
 * @param {Document} doc
 * @returns {boolean}
 */
export function legacyDialogAbove(doc) {
  const view = doc.defaultView
  return Array.from(doc.querySelectorAll('.modal, .mce-floatpanel')).some(
    (el) => {
      const style = view.getComputedStyle(el)
      // A hidden Bootstrap modal keeps its stale inline z-index, so check display too
      return (
        style.display !== 'none' &&
        style.visibility !== 'hidden' &&
        parseInt(style.zIndex, 10) > LAYERED_ABOVE_Z_INDEX
      )
    }
  )
}
